export function exception(errMessage) {
    window.AnalyticsSDK && window.AnalyticsSDK.warn(errMessage)
}

export function formatTrackName(str) {
    const toUpperCase = i => i.length == 1 ? i.toUpperCase() : (i.charAt(0).toUpperCase() + i.substring(1));
    return str.split(' ').filter(i => !!i.trim()).map(toUpperCase).join('');
}